import styled from "styled-components";
import {breakpoints, media, tokens} from '../../../theme';

export const Header = styled.div`
    width: 100%;
    margin-bottom: 16px;
    display: flex;
    flex-direction: column;
    gap: 12px;

    > .title-row {
      width: 100%;
      display: flex;
      flex-direction: column;
      gap: 12px;

      h2 {
        margin: 0;
        flex: 1;
      }

      button {
        width: 100%;
      }
    }

    ${media.sm} {
      > .title-row {
        flex-direction: row;
        align-items: center;

        button {
          width: auto;
          margin-left: auto;
        }
      }
    }
`;

export const StyledDocumentsListContent = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 100px;
    min-width: ${breakpoints.sm};
    overflow: auto;
`;

export const StyledDocumentsListWrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

export const LoadingWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 48px;
    width: 100%;
    height: 100%;
`;

export const StyledPageSizeLabel = styled.p`
    padding: 6px;
    font-size: ${tokens.fontSize.base};
`;

export const PageSizeWrapper = styled.div`
    display: flex;
    justify-content: right;
`;